import firebase from "firebase"

export default {
   name: 'Login',
   data() {
      return {
         email   : '',
         password: ''
      }
   },
   methods: {
      login() {
         let admins = ['adrianmoviles14@gmail.com', 'priscillaparedesosorio@gmail.com', 'Kiaralexandra49@gmail.com', 'yanhezv@gmail.com']
         let isAdmin = admins.indexOf(this.email) != -1
         if (isAdmin) {
            firebase.auth().signInWithEmailAndPassword(this.email,this.password)
               .then((response)=>{
                  let user = {
                     email : response.user.email,
                     userId: response.user.uid
                  }
                  this.message(1, 'Bienvenido al Sistema Tejesol.')
                  this.$store.dispatch('userSystem', user)
                  this.$router.replace({ name: 'welcome' })
               })
               .catch((error) => {
                  this.message(0, error.message)
               })
         } else {
            this.message(1, 'Esta cuenta no tiene permisos para ingresar.')
         }
      },
      message(status, text) {
         this.$q.notify({
            type: status == 1 ? 'positive' : 'negative',
            message: text,
            position: 'top-right'
         })
      }
   }
}
